import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchArticleById } from '../utils/api';
import HomePage from './HomePage';

const ArticleDirectLink = ({ selectedRegions, excludedCategories, onFilterClick, onArticleLoad }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  // Reset hasLoaded when id changes
  useEffect(() => {
    setHasLoaded(false);
    setIsLoading(true);
    setError(false);
  }, [id]);

  useEffect(() => {
    // Prevent loading the same article multiple times
    if (hasLoaded) return;
    
    const loadArticle = async () => {
      try {
        setHasLoaded(true);
        // Fetch the article data
        const articleData = await fetchArticleById(id);
        
        if (articleData) {
          // Open modal after component mounts - mark as direct visit
          setTimeout(() => {
            onArticleLoad(articleData, true);
          }, 100);
        } else {
          // Article not found
          setError(true);
        }
      } catch (error) {
        console.error('Error loading article for direct link:', error);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      loadArticle();
    } else {
      setError(true);
      setIsLoading(false);
    }
  }, [id, hasLoaded]); // eslint-disable-line react-hooks/exhaustive-deps
  // Note: onArticleLoad is intentionally excluded to prevent infinite loop since it's recreated on every parent render

  // Handle error - redirect to homepage
  useEffect(() => {
    if (error && !isLoading) {
      navigate('/', { replace: true });
    }
  }, [error, isLoading, navigate]);

  // Show loading spinner while loading
  if (isLoading) {
    return (
      <div className="article-page">
        <div className="loading-container">
          <div className="loading-spinner">
            <svg viewBox="0 0 50 50" className="spinner">
              <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
            </svg>
          </div>
          <p>Laddar artikel...</p>
        </div>
      </div>
    );
  }

  // If error, component will redirect via useEffect
  if (error) {
    return null;
  }

  // Render homepage with article modal on top
  return (
    <HomePage 
      selectedRegions={selectedRegions}
      excludedCategories={excludedCategories}
      onFilterClick={onFilterClick}
      onArticleClick={onArticleLoad}
    />
  );
};

export default ArticleDirectLink;
